// Cache management functions
const cacheKeyPrefix = 'SportsMode_API_'

export const getCachedOrFetch = async (key, url, get) => {
  const cacheKey = `${cacheKeyPrefix}${key}`
  const cachedData = localStorage.getItem(cacheKey)
  
  if (cachedData) {
    console.log(`Returning cached value from localStorage: ${cacheKey}`, { data: JSON.parse(cachedData) })
    return { data: JSON.parse(cachedData) }
  }

  console.log('Fetching from API:', url)
  const response = await get(url)
  localStorage.setItem(`${cacheKey}-original`, JSON.stringify(response.data))

  return response
}

export const getCachedOrPost= async (key, url, post, payload) => {
  const cacheKey = `${cacheKeyPrefix}${key}`
  const cachedData = localStorage.getItem(cacheKey)
  
  if (cachedData) {
    console.log(`Returning cached value from localStorage: ${cacheKey}`, { data: JSON.parse(cachedData) })
    return { data: JSON.parse(cachedData) }
  }

  console.log('Fetching from API:', url)
  const response = await post(url, payload)
  localStorage.setItem(`${cacheKey}-original`, JSON.stringify(response.data))

  return response
}
